/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import UnderOverType from '@views/Matchup/MatchUpDetail/OutcomeBlockType/UnderOverType'
import { TypeProps } from '../OutcomeBlockNew'

/**
 * 더블찬스+언더오버 조합 형태 마켓에 주로 사용
 * 테이블 상단 컬럼: 아웃컴 이름 (ex. 홈/무, 홈/원정, 원정/무)
 * 테이블 좌측 컬럼: 언더 기준점, 오버 기준점 (ex.언더 1.5, 오버1.5)
 *
 * @param {TypeProps} props
 */
const Type5: React.FC<TypeProps> = (props: TypeProps) => {

  const { initialOutcomeCount, markets } = props

  const viewKeyPrefix = 'OutcomeBlockType:Type5:'

  const outcomeHeadOrders = []
  for (let i = 1; i <= initialOutcomeCount / 2; i += 1) {
    outcomeHeadOrders.push(i)
  }

  const makeUnderOutcomeIndexes = () => {
    const result: number[] = []
    const endIndex = initialOutcomeCount / 2
    for (let i = 1; i <= endIndex; i += 1) {
      result.push(i)
    }
    return result
  }

  const makeOverOutcomeIndexes = () => {
    const result: number[] = []
    const startIndex = (initialOutcomeCount / 2) + 1
    for (let i = startIndex; i <= initialOutcomeCount; i += 1) {
      result.push(i)
    }
    return result
  }

  const underOutcomeIndexes = makeUnderOutcomeIndexes()
  const overOutcomeIndexes = makeOverOutcomeIndexes()
  const underOverTypeProps = { ...props, outcomeHeadOrders, underOutcomeIndexes, overOutcomeIndexes }

  return (
    <Fragment>
      <UnderOverType key={`${viewKeyPrefix}_${markets[0].id}`} {...underOverTypeProps}/>
    </Fragment>
  )
}

export default observer(Type5)
